import { AuthStep } from '@/enums/auth/authStep';
import useAuthSearchParams from '@/hooks/auth/useAuthSearchParams';
import UserIdentityForm from '@starsoft/common/components/KYC/UserIdentity/Form';
import AuthModalContentLoginStepsForm from '../../Form';
import { useSystemConfiguration } from '@/hooks/theme/useSystemConfiguration';

export default function AuthModalContentLoginStepsOriginRendererBrazil() {
  const { step } = useAuthSearchParams();
  const { originId } = useSystemConfiguration();

  switch (step) {
    case AuthStep.Form:
      return <AuthModalContentLoginStepsForm />;
    case AuthStep.Kyc:
      return <UserIdentityForm usePartialForm externalOriginId={originId} />;
    default:
      return <AuthModalContentLoginStepsForm />;
  }
}
